import { httpDelete, httpGet, httpPost } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { ScopeTemplate } from '../types/ScopeTemplate';
import { SingleResult } from '../types/SingleResult';

const addScopeTemplate = async (name: string): Promise<ScopeTemplate> => {
  return await httpPost<ScopeTemplate>(`api/scope/template`, name);
};

const deleteScopeTemplate = async (id: string): Promise<void> => {
  return await httpDelete(`api/scope/template/${id}`);
};

const getScopeTemplate = async (id: string): Promise<ScopeTemplate> => {
  return await httpGet<ScopeTemplate>(`api/scope/template/${id}`);
};

const getScopeTemplates = async (request: PaginatedRequest): Promise<PaginatedResult<ScopeTemplate>> => {
  return await httpGet<PaginatedResult<ScopeTemplate>>(`api/scope/template`, request);
};

const getScopeTemplatesAssignedToUser = async (userId: string): Promise<SingleResult<ScopeTemplate[]>> => {
  return await httpGet<SingleResult<ScopeTemplate[]>>(`api/scope/template/user/${userId}`);
};

const addScopeTemplateToUser = async (userId: string, templateId: string): Promise<SingleResult<ScopeTemplate[]>> => {
  return await httpPost<SingleResult<ScopeTemplate[]>>(`api/scope/template/user/${userId}/${templateId}`);
};

const removeScopeTemplateFromUser = async (userId: string, templateId: string): Promise<SingleResult<ScopeTemplate[]>> => {
  return await httpDelete<SingleResult<ScopeTemplate[]>>(`api/scope/template/user/${userId}/${templateId}`);
};

const searchScopeTemplates = async (wildcard: string): Promise<SingleResult<ScopeTemplate[]>> => {
  return await httpGet<SingleResult<ScopeTemplate[]>>(`api/scope/template/search/${wildcard}`);
};

export {
  addScopeTemplate,
  deleteScopeTemplate,
  addScopeTemplateToUser,
  getScopeTemplate,
  getScopeTemplates,
  getScopeTemplatesAssignedToUser,
  removeScopeTemplateFromUser,
  searchScopeTemplates,
};
